"use client";

import { useState } from "react";
import { motion } from "framer-motion";
import DesktopNavbar from "@components/utils/navbar/DesktopNavbar";
import MobileNavbar from "@components/utils/navbar/MobileNavbar";
import { useMediaQuery } from "@/app/(site)/_hooks/useMediaQuery";

export default function Header() {
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const isDesktop = useMediaQuery("(min-width: 990px)");

	const openMobileMenu = () => setIsMobileMenuOpen(true);
	const closeMobileMenu = () => setIsMobileMenuOpen(false);

	if (isDesktop) {
		return (
			<header className="fixed top-1 z-30 w-full">
				<div className="flex items-center justify-center sm:px-[3.75rem] sm:py-5">
					<DesktopNavbar />
				</div>
			</header>
		);
	}

	return (
		<motion.header
			className="fixed z-30 w-full"
			initial={{ top: "0.438rem" }}
			animate={{
				top: isMobileMenuOpen ? 0 : "0.438rem",
			}}
			transition={{
				duration: 0.3,
				ease: "easeInOut",
			}}
		>
			<div className="flex items-center justify-center">
				<MobileNavbar isMenuOpen={isMobileMenuOpen} onOpenMenu={openMobileMenu} onCloseMenu={closeMobileMenu} />
			</div>
		</motion.header>
	);
}
